import React, { useEffect, useState } from 'react'
import { ButtonDropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import { SwapGrayIcon, SwapIcon } from '../../../assets/images';
import { RadioContainer } from '../../../components/commons';

const CLIENT_DIRECTORY_SORTING = [
    {
        id: "Recently Added/Modified First",
        value: "",
        name: "Recently Added/Modified First"
    },
    {
        id: "Job Type - A to Z",
        value: "asc",
        name: "Job Type - A to Z"
    },
    {
        id: "Job Type - Z to A",
        value: "desc",
        name: "Job Type - Z to A"
    },
    {
        id: "Code - Ascending",
        value: "asc",
        name: "Code - Ascending"
    },
    {
        id: "Code - Descending",
        value: "desc",
        name: "Code - Descending"
    }
]

type AppProps = {
    data: any;
    handleChange: any;
    selectedData: { name: string, value: string }
    history?:any;
}

const RecurringJobSorting = ({
    data,
    handleChange,
    selectedData,
    history
}: AppProps) => {
    delete history?.location?.state?.jobType
    delete history?.location?.state?.sortByCc

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [sortingData, setSortingData] = useState({ name: "", value: "" })
    const handleRadioValueChange = (data: any) => {
        if (data === "Job Type - A to Z") {
            setSortingData({ name: data, value: "asc" })
        }
        else if (data === "Job Type - Z to A") {
            setSortingData({ name: data, value: "desc" })
        }
        else if (data === "Code - Ascending") {
            setSortingData({ name: data, value: "asc" })
        }
        else if (data === "Code - Descending") {
            setSortingData({ name: data, value: "desc" })
        }
        else if (data === "Recently Added/Modified First") {
            setSortingData({ name: data, value: "" })
        }
    }
    useEffect(() => {
        handleChange(sortingData)
    }, [sortingData])
    return (
        <ButtonDropdown
            isOpen={isOpen}
            toggle={() => {
                setIsOpen(!isOpen)
            }}
        >
            <DropdownToggle
                caret
                color="secondary"
                style={
                    isOpen
                        ? {
                            color: "#dd4433",
                            border: "1px solid #dd4433",
                            backgroundColor: "#fff6f5",
                        }
                        : { border: "1px solid#bfcbe1" }
                }
                outline
            >
                <img src={selectedData?.value ? SwapIcon : SwapGrayIcon} alt="" />
            </DropdownToggle>

            <DropdownMenu right>
                <div className='p-3 sort-menu' style={{ width: "310px" }}>
                    <div
                        style={{ padding: "5px" }}
                        onClick={() => {
                            setIsOpen(!isOpen)
                        }}>
                        <h5 className='text-start '>Sort By</h5>
                        <hr className='mt-0 mb-0' />
                        <RadioContainer
                            optionsList={CLIENT_DIRECTORY_SORTING}
                            handleSetRadioValue={handleRadioValueChange}
                            radioValue={selectedData?.name?selectedData?.name:"Recently Added/Modified First"}
                            alignment="vertical"
                            backGround={true}
                        />
                    </div>
                </div>
            </DropdownMenu>
        </ButtonDropdown>
    )
}

export default RecurringJobSorting